export const getEmailHistory = (rloc, emailHistArr) => {
  let output = null
  let historyIsArr = Array.isArray(emailHistArr) && emailHistArr.length

  if (historyIsArr) {
    // NOTE // get emailRecords that are for this rloc (record locator)
    let rlocEmails = emailHistArr.filter(emailRecord => emailRecord.rloc == rloc)
    // NOTE // loop over emails for this rloc
    for (let i = 0; i < rlocEmails.length; i++) {
      const emailRecord = rlocEmails[i];
      // NOTE // if the output is already true, exit the loop (the output being true means an itin has successfully sent for this rloc)
      if (output === true) {
        break
      }
      // NOTE // we only care about itineraries currently
      if (emailRecord?.template_id.includes('itin')) {
        output = emailRecord.status
      }
    }
  }

  console.log(output)

  return output
}